import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../../../infrastructure/infrastructure.module';
import { Observable } from 'rxjs';
import { api } from '@bayclubs/utils'
import { camps } from '../../models/models.generated';

@Injectable()
export class DiscountManagementApiService {

    constructor(private http: ApiHttpClient) { }


    public save(request: camps.DiscountSaveRequest): Observable<api.OperationResultValue<camps.DiscountDefinitionDetails>> {
        return this.http.post<api.OperationResultValue<camps.DiscountDefinitionDetails>>(`discount`, request, true);
    }

    public remove(request: camps.DiscountRemoveRequest): Observable<api.OperationResult> {
        return this.http.post<api.OperationResult>(`discount/remove`, request, true);
    }
}
